import { Nullable } from '../../types/common'
import BaseComponent from '../base-component/base-component'

class ColorSwatchesPicker extends BaseComponent {
  activeValueSelector: string
  activeValue: Nullable<HTMLElement>
  labelSelector: string
  labels: Element[]

  constructor() {
    super()

    this.activeValueSelector = '[data-color-swatches-picker-active-value]'
    this.activeValue = this.querySelector(this.activeValueSelector)

    this.labelSelector = '[data-color-swatches-picker-label]'

    this.labels = [...this.querySelectorAll(this.labelSelector)]

    this.form = this.closest('variant-picker').form
  }

  connectedCallback(): void {
    this.form.addEventListener('change', this.handleFormChange)

    this.labels.forEach(label => {
      label.addEventListener('mouseenter', this.handleMouseEnter)
      label.addEventListener('mouseleave', this.handleMouseLeave)
    })
  }

  disconnectedCallback(): void {
    this.form.removeEventListener('change', this.handleFormChange)

    this.labels.forEach(label => {
      label.removeEventListener('mouseenter', this.handleMouseEnter)
      label.removeEventListener('mouseleave', this.handleMouseLeave)
    })
  }

  handleFormChange = (): void => {
    this.updateSelected()
  }

  handleMouseEnter = (event): void => {
    this.updateActiveValue(event.target.dataset.value)
  }

  handleMouseLeave = (): void => {
    this.updateSelected()
  }

  updateSelected(): void {
    const selectedLabel = this.querySelector(`${this.labelSelector}.selected`)

    if (selectedLabel) {
      const value = selectedLabel.getAttribute('data-value') || ''

      this.updateActiveValue(value)
    }
  }

  updateActiveValue(value: string): void {
    if (this.activeValue) {
      this.activeValue.textContent = value
    }
  }
}

export default ColorSwatchesPicker
